module.exports = __webpack_public_path__ + "static/media/logo.white.6686fc0c.svg";